import React, { lazy, Suspense } from 'react'
import {
  Clock,
  Shield,
  ClipboardCheck,
  Bus,
  Users,
  ArrowUpRight,
  DollarSign,
  Award,
  PhoneCall,
  UserCheck,
  Sparkles,
  Banknote,
} from 'lucide-react'
const Hero = lazy(() => import('./inner_components/Hero'))

const WhyChooseUs = () => {
  const heroBenefits = [
    {
      icon: <PhoneCall className="w-6 h-6 text-white" />,
      text: '24/7 Customer Support',
    },
    {
      icon: <UserCheck className="w-6 h-6 text-white" />,
      text: 'Professional Drivers',
    },
    {
      icon: <Sparkles className="w-6 h-6 text-white" />,
      text: 'Clean and Sanitized Vehicles',
    },
    {
      icon: <Banknote className="w-6 h-6 text-white" />,
      text: 'Affordable Pricing',
    },
  ]

  const benefits = [
    {
      icon: <Clock className="w-12 h-12 text-[#1865a5]" />,
      title: 'Technology-Driven Solutions',
      description:
        'Real-time tracking and monitoring with 24/7 support for maximum efficiency and safety.',
    },
    {
      icon: <Shield className="w-12 h-12 text-[#1865a5]" />,
      title: 'Safe, Reliable, and Comfortable Travel',
      description:
        'Prioritizing employee safety and comfort with well-maintained vehicles and professional drivers.',
    },
    {
      icon: <ClipboardCheck className="w-12 h-12 text-[#1865a5]" />,
      title: 'Compliance and Transparency',
      description:
        'Digitized compliance management and transparent billing systems for peace of mind.',
    },
    {
      icon: <Bus className="w-12 h-12 text-[#1865a5]" />,
      title: 'Wide Range of Fleet Options',
      description:
        'Fleet options ranging from 4-seaters to 50-seaters, catering to all corporate needs.',
    },
    {
      icon: <Users className="w-12 h-12 text-[#1865a5]" />,
      title: 'High Driver Retention Rate',
      description:
        'Experienced and well-trained drivers with industry-leading retention rates.',
    },
    {
      icon: <ArrowUpRight className="w-12 h-12 text-[#1865a5]" />,
      title: 'Business Continuity Support',
      description:
        'Experts in ensuring uninterrupted transportation during business challenges or crises.',
    },
    {
      icon: <DollarSign className="w-12 h-12 text-[#1865a5]" />,
      title: 'Cost-Effective Services',
      description:
        'We offer high-quality transportation solutions at competitive rates, making us the preferred choice for businesses seeking value without compromising on quality.',
    },
    {
      icon: <Award className="w-12 h-12 text-[#1865a5]" />,
      title: 'Commitment to Excellence',
      description:
        'At RoyalRise, we are driven by a commitment to exceed expectations, fostering trust and long-term partnerships with our corporate clients.',
    },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section with new benefits */}
      <div className="relative" data-aos="fade-down" data-aos-duration="500">
        <Suspense
          fallback={<div className="h-[35rem] bg-gray-200 animate-pulse" />}
        >
          <Hero
            tagline="Why Choose Us?"
            title="What Sets Us Apart"
            description="Discover the RoyalRise advantage in corporate transportation"
            bgImage="/images/whytochoose1.jpeg"
          />
        </Suspense>

        {/* New Hero Benefits Section */}
        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {heroBenefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-center justify-center space-x-3"
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={index * 50}
                >
                  <div className="flex-shrink-0">{benefit.icon}</div>
                  <span className="text-white font-semibold text-sm md:text-base">
                    {benefit.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Benefits Grid */}
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
              data-aos="zoom-in"
              data-aos-duration="500"
              data-aos-delay={index * 50}
            >
              <div className="flex flex-col items-center text-center">
                <div
                  className="mb-6"
                  data-aos="fade-down"
                  data-aos-duration="400"
                  data-aos-delay={index * 50}
                >
                  {benefit.icon}
                </div>
                <h3
                  className="text-xl font-semibold mb-4 text-gray-900"
                  data-aos="fade-up"
                  data-aos-duration="400"
                  data-aos-delay={index * 50 + 50}
                >
                  {benefit.title}
                </h3>
                <p
                  className="text-gray-600 leading-relaxed"
                  data-aos="fade-up"
                  data-aos-duration="400"
                  data-aos-delay={index * 50 + 100}
                >
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WhyChooseUs
